import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import TextField from '@components/Form/TextField';
import Button, { SIZE, VARIANT } from '@components/Button';
import {
  Column,
  ViewChooser,
  ViewSelector,
  Wrapper,
} from '@components/SearchBar/style';
import Select from 'react-select';

const selectStyles = {
  container: provided => ({
    ...provided,
    width: '100%',
    maxWidth: '360px',
  }),
  placeholder: provided => ({
    ...provided,
    fontSize: '14px',
  }),
};

const SearchBar = ({
  downloadGoogleApis,
  view,
  toggleView,
  search,
  searchPhrase,
  withViewSwitch,
  kind,
  activeLabel,
}) => {
  const metadataOptions = [
    {
      label: 'General metadata',
      value: activeLabel?.partner_general_meta_data?.url,
    },
    {
      label: 'Harvest ingestion',
      value: activeLabel?.partner_harvest_meta_data?.url,
    },
    {
      label: 'Serial metadata',
      value: activeLabel?.partner_serial_meta_data?.url,
    },
  ].filter(option => option.value);

  return (
    <Wrapper>
      <Formik
        enableReinitialize
        initialValues={{ phrase: searchPhrase }}
        onSubmit={async ({ phrase }) => {
          await search(phrase, kind);
        }}
      >
        {({ values, resetForm }) => (
          <Form style={{ minWidth: '100px' }}>
            <TextField
              name="phrase"
              single
              icon="search"
              label="Search"
              light
              withClearButton={!!(values.phrase && !!values.phrase.length)}
              onClear={async () => {
                resetForm({ values: { phrase: '' } });
                await search('', kind);
              }}
            />
          </Form>
        )}
      </Formik>

      <Column>
        {metadataOptions.length > 0 && (
          <Select
            id="download-album"
            options={metadataOptions}
            placeholder={`EXPORT LABEL ${activeLabel?.name}`}
            styles={selectStyles}
            isSearchable={false}
            onChange={option => downloadGoogleApis(option.value)}
            value=""
          />
        )}

        {activeLabel?.partner_albums_pdf?.url ? (
          <Button
            type="button"
            text="DOWNLOAD PDF CATALOGUE"
            size={SIZE.SMALL}
            variant={VARIANT.PRIMARY}
            iconPosition="prefix"
            icon="download-circle"
            onClick={() =>
              downloadGoogleApis(activeLabel?.partner_albums_pdf?.url)
            }
          />
        ) : null}

        {withViewSwitch ? (
          <ViewSelector>
            <ViewChooser
              type="button"
              active={view === 'list'}
              onClick={() => toggleView('list')}
            >
              <img
                src={`/images/icons/list${view === 'list' ? '-on' : ''}.svg`}
                alt="list"
              />
            </ViewChooser>
            <ViewChooser
              type="button"
              active={view === 'grid'}
              onClick={() => toggleView('grid')}
            >
              <img
                src={`/images/icons/grid${view === 'grid' ? '-on' : ''}.svg`}
                alt="grid"
              />
            </ViewChooser>
          </ViewSelector>
        ) : null}
      </Column>
    </Wrapper>
  );
};

SearchBar.defaultProps = {
  view: 'list',
  withViewSwitch: false,
};

SearchBar.propTypes = {
  toggleView: PropTypes.func.isRequired,
  view: PropTypes.oneOf(['list', 'grid']),
  search: PropTypes.func.isRequired,
  searchPhrase: PropTypes.string.isRequired,
  withViewSwitch: PropTypes.bool,
  kind: PropTypes.oneOf(['albums', 'tracks', 'labels']).isRequired,
};

export default memo(SearchBar);
